import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%'
  },

  loading: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '40px',
    height: '40px'
  }
}))

export default useStyles
